<template>
  <div class="gift-config-page" style="padding:20px;background:#f2f3f5;min-height:100vh">
    <el-row :gutter="20">
      <!-- 左侧：礼包模板列表 -->
      <el-col :span="6">
        <el-card shadow="hover">
          <template #header>
            <div class="header-row">
              <span class="title">礼包模板列表</span>
              <el-button type="primary" size="small" @click="openAddDialog">新增模板</el-button>
            </div>
          </template>
          <el-scrollbar height="620px">
            <div class="gift-item-wrap">
              <div
                class="gift-item"
                :class="{active: selectedGift?.id === row.id}"
                v-for="row in tableData"
                :key="row.id"
                @click="selectGift(row)"
              >
                <span>{{ row.gift_name }}</span>
                <el-tag v-if="isAnchor(row)" size="small" type="danger" style="margin-left:8px">主播固定</el-tag>
              </div>
            </div>
          </el-scrollbar>
        </el-card>
      </el-col>
      <!-- 右侧区域 -->
      <el-col :span="18">
        <!-- 上：选中礼包模板详情 -->
        <el-card v-if="selectedGift" shadow="hover" style="margin-bottom:20px">
          <template #header>
            <div class="header-row">
              <span class="title">礼包模板详情</span>
              <div class="btn-group">
                <el-button size="small" @click="openAddDialog(selectedGift)">编辑模板</el-button>
                <!-- 主播固定模板：禁用生成礼包码和删除按钮 -->
                <el-button
                  v-if="!isAnchor(selectedGift)"
                  size="small"
                  type="success"
                  @click="openGenDialog(selectedGift)"
                >生成礼包码</el-button>
                <el-button
                  v-if="!isAnchor(selectedGift)"
                  size="small"
                  type="danger"
                  @click="delRow(selectedGift)"
                >删除模板</el-button>
              </div>
            </div>
          </template>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="gift_type">{{ selectedGift.gift_type }}</el-descriptions-item>
            <el-descriptions-item label="礼包名称">{{ selectedGift.gift_name }}</el-descriptions-item>
            <el-descriptions-item label="模板类型">
              <el-tag :type="isAnchor(selectedGift) ? 'danger':'primary'">
                {{ isAnchor(selectedGift) ? "主播固定模板":"普通礼包模板" }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="奖品清单" :span="3">
              <div v-for="(item, idx) in giftPrizeList(selectedGift.item_info)" :key="idx" class="prize-item">
                <span>奖品名称：{{item.item_name}}</span>
                <span style="margin-left:20px">数量：{{item.count}}</span>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
        <!-- 下：礼包码列表区域 -->
        <el-card v-if="selectedGift" shadow="hover">
          <template #header>
            <div class="header-row">
              <span class="title">礼包码列表</span>
              <div class="search-wrap">
                <el-input
                  v-model="searchCode"
                  placeholder="按礼包码key查询"
                  size="small"
                  style="width:200px;margin-right:10px"
                  clearable
                ></el-input>
                <el-input
                  v-model="searchRole"
                  placeholder="按角色名role查询"
                  size="small"
                  style="width:200px"
                  clearable
                ></el-input>
              </div>
            </div>
          </template>
          <el-table :data="filterCodeList" border stripe height="440">
            <el-table-column label="ID" prop="id" width="70"/>
            <el-table-column label="礼包码key" prop="key"/>
            <el-table-column label="玩家账号user_name" prop="user_name"/>
            <el-table-column label="角色名role" prop="role"/>
            <el-table-column label="大区server_name" prop="server_name"/>
            <!-- 主播模板隐藏状态列 -->
            <el-table-column v-if="!isAnchor(selectedGift)" label="发放状态status" prop="status" width="110">
              <template #default="scope">
                <el-tag :type="getStatusTag(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="create_time"/>
            <el-table-column v-if="!isAnchor(selectedGift)" label="兑换时间" prop="use_time"/>
            <el-table-column label="操作" width="140">
              <template #default="scope">
                <el-button
                  v-if="isAnchor(selectedGift) || scope.row.status === 0"
                  size="small"
                  type="warning"
                  @click="handleSetSend(scope.row)"
                >{{ isAnchor(selectedGift) ? "标记信息":"标记已发放" }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div v-else class="empty-tip">
          <el-empty description="请点击左侧礼包名称查看详情与礼包码"></el-empty>
        </div>
      </el-col>
    </el-row>
    <!-- 新增/编辑 礼包模板弹窗【奖品可视化，不再手动写JSON】 -->
    <el-dialog v-model="configDialog.visible" title="礼包模板配置" width="700px">
      <el-form :model="configForm" label-width="110px">
        <el-form-item label="礼包类型标识">
          <el-input v-model="configForm.gift_type" placeholder="例如 gift_a 唯一标识" :disabled="isAnchor(configForm)"></el-input>
        </el-form-item>
        <el-form-item label="礼包名称">
          <el-input v-model="configForm.gift_name" placeholder="礼包A"></el-input>
        </el-form-item>
        <el-form-item label="是否主播固定模板">
          <el-switch v-model="configForm.is_anchor" active-value="1" inactive-value="0"></el-switch>
          <span style="color:#999;margin-left:10px">主播模板：禁止删除、禁止生成礼包码</span>
        </el-form-item>
        <el-form-item label="奖品配置列表">
          <div class="prize-editor-wrap">
            <el-row v-for="(prize, index) in prizeList" :key="index" :gutter="12" style="margin-bottom:8px">
              <el-col :span="12">
                <el-input v-model="prize.item_name" placeholder="奖品名称"></el-input>
              </el-col>
              <el-col :span="8">
                <el-input-number v-model="prize.count" :min="1" style="width:100%"></el-input-number>
              </el-col>
              <el-col :span="4">
                <el-button type="danger" icon="el-icon-delete" @click="prizeList.splice(index,1)"></el-button>
              </el-col>
            </el-row>
            <el-button type="primary" size="small" @click="prizeList.push({item_name:'',count:1})">+ 添加奖品</el-button>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="configDialog.visible=false">取消</el-button>
        <el-button type="primary" @click="saveConfig" :loading="saveLoading">保存</el-button>
      </template>
    </el-dialog>
    <!-- 批量生成礼包码弹窗 -->
    <el-dialog v-model="genDialog.visible" title="批量生成礼包码" width="600px">
      <el-form :model="genForm">
        <el-form-item label="当前gift_type">
          <el-input v-model="genForm.gift_type" disabled/>
        </el-form-item>
        <el-form-item label="生成数量">
          <el-input-number v-model="genForm.count" :min="1" :max="1000"></el-input-number>
        </el-form-item>
        <el-form-item v-if="codeResultList.length>0">
          <div class="header-row">
            <label>生成礼包码列表：</label>
            <el-button size="small" @click="copyCodeList">一键复制</el-button>
          </div>
          <el-input :value="codeText" type="textarea" rows="8" readonly/>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="genDialog.visible=false">关闭</el-button>
        <el-button type="primary" @click="genGiftCode" :loading="genLoading">开始生成</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { GAME_API } from '@/utils/apiBase';
import {ref,onMounted,computed} from 'vue'
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
const baseUrl = `${GAME_API}`

// axios拦截器：所有请求自动带上sessionStorage的token
axios.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, err => Promise.reject(err))

axios.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401) {
    sessionStorage.removeItem('token')
    ElMessage.error('登录失效，请重新登录')
  }
  return Promise.reject(err)
})

const tableData = ref([])
const saveLoading = ref(false)
const genLoading = ref(false)
const selectedGift = ref(null)
const giftCodeList = ref([])
const searchCode = ref('')
const searchRole = ref('')
const configDialog = ref({visible:false})
const configForm = ref({
  id:null,
  gift_type:'',
  gift_name:'',
  is_anchor:0,
  item_info:'[]'
})
// 奖品列表（可视化编辑）
const prizeList = ref([{item_name:"碧灵丹",count:5}])
const genDialog = ref({visible:false})
const genForm = ref({gift_type:'',count:10})
const codeResultList = ref([])
const codeText = computed(()=>{
  return codeResultList.value.join('\n')
})
// ==========【关键修复】判断是否主播模板，兼容数字1、字符串"1"、undefined ==========
// ==========【修复】使用gift_type判断主播模板 ==========
function isAnchor(row){
  if(!row) return false
  // gift_type等于anchor 就判定为主播模板
  return row.gift_type === 'anchor'
}
// 把后端json奖品字符串转成页面渲染列表
function giftPrizeList(jsonStr) {
  try{
    return JSON.parse(jsonStr)
  }catch(err){
    return []
  }
}
// 过滤礼包码：key礼包码 / role角色名
const filterCodeList = computed(()=>{
  return giftCodeList.value.filter(item=>{
    const matchKey = !searchCode.value || item.key?.includes(searchCode.value)
    const matchRole = !searchRole.value || (item.role && item.role.includes(searchRole.value))
    return matchKey && matchRole
  })
})
// 状态文本与标签颜色
function getStatusText(status){
  const map = {
    0: "未发放",
    1: "已发放",
    2: "已兑换"
  }
  return map[status] || "未知"
}
function getStatusTag(status){
  const map = {
    0: "info",
    1: "warning",
    2: "success"
  }
  return map[status] || "danger"
}
// 加载礼包模板列表
function loadList(){
  axios.get(`${baseUrl}/api/GiftCard/GetConfigList`).then(res=>{
    if(res.data.code===200){
      tableData.value = res.data.data
      // 调试：打印第一条数据，看后端到底返回了哪些字段
      console.log("后端返回模板列表：", res.data.data)
      if(res.data.data.length > 0){
        console.log("第一条模板字段：", Object.keys(res.data.data[0]))
      }
    }
  }).catch(err=>{
    ElMessage.error("加载礼包模板失败："+err.message)
  })
}
// 选中模板，根据is_anchor判断请求哪个接口
async function selectGift(row){
  selectedGift.value = row
  searchCode.value = ''
  searchRole.value = ''
  giftCodeList.value = []
  console.log("选中模板完整数据：", row)
  console.log("isAnchor判断结果：", isAnchor(row))
  try{
    let res
    if(isAnchor(row)){
      // 主播固定模板：查主播码表 extern_user_anchor
      console.log("走主播码接口 GetAnchorCodeList")
      res = await axios.get(`${baseUrl}/api/GiftCard/GetAnchorCodeList`)
    }else{
      // 普通礼包模板：查gift_code礼包码表
      console.log("走普通礼包码接口 GetGiftCodeList")
      res = await axios.get(`${baseUrl}/api/GiftCard/GetGiftCodeList`,{
        params:{ gift_type: row.gift_type }
      })
    }
    if(res.data.code ===200){
      giftCodeList.value = res.data.data
    }
  }catch(err){
    ElMessage.error("加载码列表失败："+err.message)
  }
}
// 标记发放，区分主播码/礼包码，调用不同后端接口
// 替换 handleSetSend 函数，只做确认，不需要输入
async function handleSetSend(row) {
  try {
    await ElMessageBox.confirm(
      `码【${row.key}】确认标记已发放？`,
      '标记信息',
      {
        confirmButtonText: '确认保存',
        cancelButtonText: '取消',
        type: 'info'
      }
    )
    // 这里改成 UpdateGiftCodeStatus
    const res = await axios.post(`${baseUrl}/api/GiftCard/UpdateGiftCodeStatus`,{
      id: row.id,
      status: 1
    })
    if(res.data.code === 200){
      ElMessage.success("标记成功");
      // 刷新当前礼包码列表
      selectGift(selectedGift.value)
    }
  } catch(err) {
    // 取消弹窗不报错
    if(err === 'cancel'){
      return
    }
    ElMessage.error("标记失败：" + err.message)
  }
}
// 打开新增/编辑弹窗
function openAddDialog(row=null){
  configDialog.value.visible=true
  if(row){
    configForm.value = {...row}
    // 读取json奖品，填充到可视化奖品列表
    prizeList.value = giftPrizeList(row.item_info)
  }else{
    configForm.value = {id:null,gift_type:'',gift_name:'',is_anchor:0,item_info:'[]'}
    prizeList.value = [{item_name:"碧灵丹",count:5}]
  }
}
// 保存模板：前端奖品数组打包为JSON传给后端
async function saveConfig(){
  // 把prizeList序列化为json
  configForm.value.item_info = JSON.stringify(prizeList.value)
  saveLoading.value = true
  try{
    const res = await axios.post(`${baseUrl}/api/GiftCard/SaveConfig`,configForm.value)
    if(res.data.code===200){
      ElMessage.success("保存成功")
      configDialog.value.visible=false
      loadList()
      if(selectedGift.value && selectedGift.value.id === configForm.value.id){
        selectedGift.value = {...configForm.value}
      }
    }else{
      ElMessage.error(res.data.msg || "保存失败")
    }
  }catch(err){
    ElMessage.error("请求异常："+err.message)
  }finally{
    saveLoading.value = false
  }
}
// 删除模板 - GET版本
async function delRow(row){
  ElMessageBox.confirm(
    `确定删除礼包模板【${row.gift_name}】吗？`,
    '警告',
    {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}
  ).then(async ()=>{
    const res = await axios.get(`${baseUrl}/api/GiftCard/DeleteConfig`,{
      params: {
        gift_name: row.gift_name
      }
    })
    if(res.data.code===200){
      ElMessage.success("删除成功")
      loadList()
      if(selectedGift.value?.gift_name === row.gift_name){
        selectedGift.value = null
        giftCodeList.value = []
      }
    }else{
      ElMessage.error(res.data.msg || "删除失败")
    }
  }).catch(()=>{})
}


function openGenDialog(row){
  genDialog.value.visible=true
  genForm.value.gift_type = row.gift_type
  genForm.value.count=10
  codeResultList.value=[]
}
async function genGiftCode(){
  genLoading.value = true
  try{
    const res = await axios.post(`${baseUrl}/api/GiftCard/BatchCreateGiftCode`,genForm.value)
    if(res.data.code===200){
      ElMessage.success(`成功生成${res.data.data.length}条礼包码`)
      codeResultList.value = res.data.data
      setTimeout(()=>{
        selectGift(selectedGift.value)
      },500)
    }else{
      ElMessage.error(res.data.msg || "生成礼包码失败")
    }
  }catch(err){
    ElMessage.error("请求异常："+err.message)
  }finally{
    genLoading.value = false
  }
}
async function copyCodeList(){
  await navigator.clipboard.writeText(codeText.value)
  ElMessage.success("礼包码复制成功！")
}
onMounted(()=>loadList())
</script>
<style scoped>
.header-row{
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.title{
  font-weight:bold;
  font-size:16px;
}
.gift-item{
  padding: 10px 14px;
  cursor: pointer;
  border-radius:6px;
  margin-bottom:6px;
  display:flex;
  align-items:center;
  transition:0.2s;
}
.gift-item:hover{
  background-color:#ecf5ff;
}
.gift-item.active{
  background-color:#409eff;
  color:#fff;
}
.empty-tip{
  height:700px;
  display:flex;
  align-items:center;
  justify-content:center;
  background:#fff;
  border-radius:8px;
}
.prize-item{
  padding:4px 0;
}
.prize-editor-wrap{
  border:1px solid #eee;
  padding:12px;
  border-radius:6px;
}
</style>
